// Root Zustand store. Spec §4.2.
//
// Six slices composed flat under a single Immer middleware. Each slice
// factory is typed against `AppState` so cross-slice `get()` calls (e.g.
// the edits slice reading predictions for the qualified-guard) are
// type-correct.

import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { createEditsSlice, type EditsSlice } from './edits';
import { createHistorySlice, type HistorySlice } from './history';
import { createPredictionsSlice, type PredictionsSlice } from './predictions';
import { createSecPoseSlice, type SecPoseSlice } from './secpose';
import { createSelectionSlice, type SelectionSlice } from './selection';
import { createSessionSlice, type SessionSlice } from './session';
import { createUiSlice, type UiSlice } from './ui';
import { createVideoSlice, type VideoSlice } from './video';

export type AppState = SessionSlice &
  VideoSlice &
  PredictionsSlice &
  EditsSlice &
  SelectionSlice &
  UiSlice &
  HistorySlice &
  SecPoseSlice;

export const useStore = create<AppState>()(
  immer((set, get, api) => ({
    ...createSessionSlice(set, get, api),
    ...createVideoSlice(set, get, api),
    ...createPredictionsSlice(set, get, api),
    ...createEditsSlice(set, get, api),
    ...createSelectionSlice(set, get, api),
    ...createUiSlice(set, get, api),
    ...createHistorySlice(set, get, api),
    ...createSecPoseSlice(set, get, api),
  }))
);

/** Raw store handle — for tests + the dev-only `window.__store` debug hook. */
export const store = useStore;
